import React, { useMemo } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useParams, matchPath, Link } from 'react-router-dom';

const TABS = {
  STRUCTURE: 'structure',
  WEIGHTS: 'weights',
  RUBRICS: 'rubrics',
};

function activeTab(pathname, basePath) {
  if (pathname.startsWith(`${basePath}/rubrics`)) {
    return TABS.RUBRICS;
  }
  if (matchPath(pathname, { path: `${basePath}/weights`, exact: true })) {
    return TABS.WEIGHTS;
  }
  return TABS.STRUCTURE;
}

function OrgTabs() {
  const { workspaceId, orgId } = useParams();
  const basePath = `/w/${workspaceId}/orgs/${encodeURIComponent(orgId)}/manage`;
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const tab = useMemo(
    () => activeTab(pathname, basePath),
    [pathname, basePath]
  );

  return (
    <Nav className="tab-nav nav-underline">
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === TABS.STRUCTURE}
          data-view={TABS.STRUCTURE}
          to={basePath}
        >
          Structure
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === TABS.WEIGHTS}
          data-view={TABS.WEIGHTS}
          to={`${basePath}/weights`}
        >
          Weights
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === TABS.RUBRICS}
          data-view={TABS.RUBRICS}
          to={`${basePath}/rubrics`}
        >
          Rubrics
        </NavLink>
      </NavItem>
    </Nav>
  );
}

export default OrgTabs;
